import { compose, mdsWidget } from 'dojo/_base/declare';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import template from './templates/MusicianList.html?raw';
import domConstructTyped from 'dojo/dom-construct';
import domAttr from 'dojo/dom-attr';
import domClass from 'dojo/dom-class';
import lang from 'dojo/_base/lang';
// NOTE (JS2TS): dropped dead dojo deps (dom-style, _base/connect, on). DOM-heavy → dom-construct aliased.

const domConstruct: any = domConstructTyped;

class MusicianList extends compose(_WidgetBaseSP) {
    [key: string]: any;

    templateString: any = template;

    item: any = null;
    externalButton: any = null;
    jsonEntitylist: any = null;

    startup(): void {

        this.loadMusicians();

        domClass.remove(this.reloadBtn, "w3-hide");
    }

    loadMusicians(): void {

        //spinners.global().spin(document.getElementById('spinner_box'));
        this.StandbyStart();

        domConstruct.empty(this.tableNode);
        domClass.remove(this.tableNode);

        var url = window.appRoot + "SOV/OrchestraGetOtherMusicians";
        //var url = window.appRoot + "Orchestra/GetOtherMusiciansDispo";

        this.RequestManager.post(
            url,
            {
                associateID: this.item.ref_associate,
                projectID: this.item.ref_ev_project,
            },
            lang.hitch(this, "_onLoadMusiciansResponse"),
            lang.hitch(this, "_onLoadMusiciansError"),
            false // sync
        );
    }

    _onLoadMusiciansResponse(response: any): void {
        var jsonEntitylist = JSON.parse(response);
        console.log("_onLoadMusiciansResponse", jsonEntitylist);

        this.jsonEntitylist = jsonEntitylist;

        var bShowFunction = this.item.LvlMusicans >= 110;

        // Tabelle erzeugen....
        var table = domConstruct.create("table");
        domConstruct.place(table, this.tableNode);
        domClass.add(table, "w3-border");

        var thead = domConstruct.create("thead");
        domConstruct.place(thead, table);

        var row = domConstruct.create("tr");
        domConstruct.place(row, thead);

        // Spalten mit den Überschriften
        var col = domConstruct.create("td");
        domConstruct.place(col, row);
        domAttr.set(col, "innerHTML", "Musiker mit Diensten in meiner Funktionsgruppe");

        if (bShowFunction === true) {
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", "Instrument");
            domClass.add(col, "w3-right-align");
        }

        //col = domConstruct.create("td");
        //domConstruct.place(col, row);
        //domAttr.set(col, "innerHTML", "Einteilung (fixiert)");
        //domClass.add(col, "w3-right-align");

        var tbody = domConstruct.create("tbody");
        domConstruct.place(tbody, table);

        if (jsonEntitylist.length == 0) {
            var row = domConstruct.create("tr");
            domConstruct.place(row, thead);

            // Spalten mit den Überschriften
            var col = domConstruct.create("td");
            domAttr.set(col, "colspan", bShowFunction === true ? "2" : "1");
            domConstruct.place(col, row);
            domClass.add(col, "w3-center");
            domAttr.set(col, "innerHTML", "<i>keine Einträge</i>");
        }

        for (var i = 0; i < jsonEntitylist.length; i++) {
            var entity = jsonEntitylist[i];

            row = domConstruct.create("tr");
            domConstruct.place(row, tbody);

            // Spalten mit den Inhalten
            col = domConstruct.create("td");
            domConstruct.place(col, row);
            domAttr.set(col, "innerHTML", entity.ref_associate.gDisp_Name_Firstname);

            if (bShowFunction === true) {
                col = domConstruct.create("td");
                domConstruct.place(col, row);
                domAttr.set(col, "innerHTML", entity.ref_functional_sub_group.description);
                domClass.add(col, "w3-right-align");
            }

            //col = domConstruct.create("td");
            //domConstruct.place(col, row);
            //domAttr.set(col, "innerHTML", entity.ref_vt_duty_type_2.code);
            //domClass.add(col, "w3-right-align");
        }

        //spinners.global().stop();
        this.StandbyStop();
        if (this.externalButton != null) {
            domClass.add(this.externalButton, "w3-hide");
        }

        this._onClickShow();
    }

    _onLoadMusiciansError(error: any): void {
        console.log("_onLoadMusiciansError", error);
        //spinners.global().stop();
        this.StandbyStop();
    }

    _onClickReload(evt: any): void {
        this.loadMusicians();
    }

    _onClickHide(evt: any): void {
        domClass.add(this.tableNode, "w3-hide");
    }

    _onClickShow(evt?: any): void {
        domClass.remove(this.reloadBtn, "w3-hide");

        if (this.jsonEntitylist == null) {
            this._onClickReload(evt);
        } else {
            domClass.remove(this.tableNode, "w3-hide");
        }
    }

    postMixInProperties(): void {
        super.postMixInProperties.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
    }

}
MusicianList.prototype.declaredClass = 'WidgetCollection.SOV.legacy.Main.MusicianList';

export default mdsWidget(MusicianList);
